import { Directive, TemplateRef, inject } from '@angular/core';

/**
 * Projectable template for rendering an event card's inner content.
 * The outer positioned box is still provided by the scheduler for proper layout/drag/drop.
 * Usage:
 * <ng-template beautyappSchedulerEvent let-event let-resource="resource" let-viewMode="viewMode">
 *   <div class="event-custom">
 *     <div class="title">{{ event.title }}</div>
 *     <div class="time">{{ event.start | date:'shortTime' }} - {{ event.end | date:'shortTime' }}</div>
 *     <div class="resource">{{ resource.title }}</div>
 *   </div>
 * </ng-template>
 */
@Directive({
  selector: 'ng-template[beautyappSchedulerEvent]',
  standalone: true
})
export class BeautySchedulerEventTemplateDirective {
  readonly template = inject<TemplateRef<any>>(TemplateRef);
}
